import { AuthUser } from './auth';
import { postJson, request } from './request';

export type PaymentProvider = 'stripe' | 'dodo';

export interface BillingConfig {
  provider: PaymentProvider | null;
  enabled: boolean;
  /** Present for backward compatibility; true when provider is stripe. */
  stripeEnabled: boolean;
}

export const fetchBillingConfig = (): Promise<BillingConfig> =>
  request('/api/billing/config');

export const createCheckoutSession = async (
  plan: Exclude<AuthUser['plan'], 'free'>,
): Promise<{ url: string; user?: AuthUser; sessionId?: string }> =>
  postJson<{ url: string; user?: AuthUser; sessionId?: string }>('/api/billing/checkout', { plan });

export const confirmCheckoutSession = async (sessionId: string): Promise<AuthUser> => {
  const data = await request<{ user: AuthUser }>(
    `/api/billing/session?session_id=${encodeURIComponent(sessionId)}`,
  );
  return data.user;
};

export const createBillingPortalSession = async (): Promise<{ url: string }> =>
  postJson<{ url: string }>('/api/billing/portal', {});

export const cancelSubscription = async (): Promise<AuthUser> => {
  const data = await postJson<{ user: AuthUser }>('/api/billing/cancel', {});
  return data.user;
};

export const reactivateSubscription = async (): Promise<AuthUser> => {
  const data = await postJson<{ user: AuthUser }>('/api/billing/reactivate', {});
  return data.user;
};

export const CHECKOUT_SESSION_STORAGE_KEY = 'spotdove-checkout-session';
